import { render } from "./NotiSendMail.vue?vue&type=template&id=ead922f4"
import script from "./NotiSendMail.vue?vue&type=script&lang=js"
export * from "./NotiSendMail.vue?vue&type=script&lang=js"

import "./NotiSendMail.vue?vue&type=style&index=0&id=ead922f4&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__